export default [
  {
    path: '/wings',
    name: 'wings',
    component: () => import('@/views/wings/wings'),
    meta: {
      protected: true,
      pageTitle: 'Wings',
    },
  },
]
